import { Button, Text } from '@viapeople/components'
import { config } from '../config'
import { useFeatureFlag } from '../hooks/useFeatureFlag'

const DEMO_ALLOWED_ENVIRONMENTS = new Set(['local', 'dev'])

export const FeatureFlagDemo = ({ organizationId }: { organizationId?: string }) => {
	const { isEnabled, isLoading } = useFeatureFlag('test-new-ff', organizationId)

	// Hard gate: never render POC demo content outside local/dev, regardless of flag state.
	if (!DEMO_ALLOWED_ENVIRONMENTS.has(config.env)) {
		return null
	}

	if (isLoading || !isEnabled) {
		return null
	}

	return (
		<div className='p-6 border-2 border-primary-200 rounded-lg bg-primary-50 mb-6'>
			<div className='flex items-start justify-between mb-4'>
				<div>
					<Text variant='h4' weight='semibold' className='mb-2'>
						🎉 New Feature Enabled!
					</Text>
					<Text variant='small' className='text-neutral-700 mb-4'>
						This is a proof of concept demonstrating the "test-new-ff" feature flag. This content is only visible when
						the feature flag is enabled for your organization.
					</Text>
				</div>
			</div>

			<div className='space-y-3'>
				<div className='p-4 bg-white rounded border border-primary-200'>
					<Text variant='small' weight='semibold' className='mb-2'>
						Demo Feature Card
					</Text>
					<Text variant='xsmall' className='text-neutral-600'>
						This card represents a new feature that can be toggled on/off per organization using feature flags.
					</Text>
				</div>

				<div className='flex gap-3'>
					<Button variant='primary' size='small'>
						New Action (Demo)
					</Button>
					<Button variant='secondary' size='small'>
						Secondary Action (Demo)
					</Button>
				</div>

				<div className='mt-4 p-3 bg-white rounded border border-primary-200'>
					<Text variant='xsmall' className='text-neutral-500'>
						<strong>Feature Flag:</strong> test-new-ff | <strong>Status:</strong> Enabled ✅
					</Text>
				</div>
			</div>
		</div>
	)
}
